import Tag from './Tag'

export default class TagCategory {
  constructor(
    public id: number = 0,
    public name: string = '',
    public tags: Tag[] = [],
  ) {}
}
